import { ACCOUNTING_PROVIDER_NAMES, PAYROLL_PROVIDER_NAMES, TICKETING_PROVIDER_NAMES } from '@neo.tax/shared/constants';
import { AccountingProvider, PayrollProvider, TicketingProvider, ProviderType } from '@neo.tax/shared/graphql';

import { ProviderLogo } from '../provider-logo';
import {
  AccountingProviderCardProps,
  PayrollProviderCardProps,
  TicketingProviderCardProps,
} from './connect-account.types';
import { Connected } from './Connected';

const toPayrollProviderCardProps = ({
  analyticId,
  connected,
  provider,
}: {
  provider: PayrollProvider;
  analyticId: string;
  connected: boolean;
}): PayrollProviderCardProps => ({
  label: PAYROLL_PROVIDER_NAMES[provider],
  providerType: ProviderType.Payroll,
  icon: { node: <ProviderLogo provider={provider} />, variant: 'circular' },
  id: analyticId,
  value: provider,
  disabled: provider !== PayrollProvider.SelfReported && connected, // SelfReported is always enabled
  subContent: connected ? <Connected /> : undefined,
});

export const toPayrollProviderCards = (
  providers: { provider: PayrollProvider; analyticId: string; connected: boolean }[],
): PayrollProviderCardProps[] => providers.map((provider) => toPayrollProviderCardProps(provider));

const toAccountingProviderCard = ({
  analyticId,
  connected,
  provider,
}: {
  provider: AccountingProvider;
  analyticId: string;
  connected: boolean;
}): AccountingProviderCardProps => ({
  label: ACCOUNTING_PROVIDER_NAMES[provider],
  providerType: ProviderType.Accounting,
  icon: { node: <ProviderLogo provider={provider} />, variant: 'circular' },
  id: analyticId,
  value: provider,
  disabled: provider !== AccountingProvider.SelfReported && connected, // SelfReported is always enabled
  subContent: connected ? <Connected /> : undefined,
});

export const toAccountingProviderCards = (
  providers: { provider: AccountingProvider; analyticId: string; connected: boolean }[],
): AccountingProviderCardProps[] => providers.map((provider) => toAccountingProviderCard(provider));

const toTicketingProviderCard = ({
  analyticId,
  connected,
  provider,
}: {
  provider: TicketingProvider;
  analyticId: string;
  connected: boolean;
}): TicketingProviderCardProps => ({
  label: TICKETING_PROVIDER_NAMES[provider],
  providerType: ProviderType.Ticketing,
  icon: { node: <ProviderLogo provider={provider} />, variant: 'circular' },
  id: analyticId,
  value: provider,
  disabled: connected,
  subContent: connected ? <Connected /> : undefined,
});

export const toTicketingProviderCards = (
  providers: { provider: TicketingProvider; analyticId: string; connected: boolean }[],
): TicketingProviderCardProps[] => providers.map((provider) => toTicketingProviderCard(provider));
